import { useEffect, useState } from "react";
import { Download, Search, Trash2 } from "lucide-react";
import { adminApi } from "../api";
import { Btn, PageHead, inputCls, fmtDate } from "../components";

export default function Newsletter() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  const load = (query = q) =>
    adminApi.get(`/admin/newsletter${query ? `?q=${encodeURIComponent(query)}` : ""}`).then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(""); }, []);

  const remove = async (s) => {
    if (!window.confirm(`Remove ${s.email} from the list?`)) return;
    await adminApi.delete(`/admin/newsletter/${s.id}`);
    load();
  };

  const exportCsv = async () => {
    const r = await adminApi.get("/admin/newsletter-export", { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = "cobain-newsletter-subscribers.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-newsletter">
      <PageHead title="NEWSLETTER" sub="Every signup from the site, stored here. Export anytime — plug into Brevo/Mailchimp later.">
        <Btn variant="gold" onClick={exportCsv} data-testid="newsletter-export"><Download size={13} /> EXPORT CSV</Btn>
      </PageHead>

      <div className="flex items-center gap-3 mb-6 max-w-md">
        <div className="relative flex-1">
          <Search size={14} className="absolute left-4 top-1/2 -translate-y-1/2 text-clay" />
          <input
            className={`${inputCls} !pl-10`} placeholder="Search emails..." value={q}
            onChange={(e) => { setQ(e.target.value); load(e.target.value); }}
            data-testid="newsletter-search"
          />
        </div>
        <span className="font-mono text-[10px] tracking-[0.15em] text-clay shrink-0" data-testid="newsletter-count">{items.length} SUBSCRIBERS</span>
      </div>

      <div className="border border-woodborder" data-testid="newsletter-list">
        {items.length === 0 && <p className="p-8 font-mono text-xs text-clay text-center" data-testid="newsletter-empty">NO SUBSCRIBERS FOUND.</p>}
        {items.map((s, i) => (
          <div key={s.id} className="flex items-center gap-4 px-4 md:px-6 py-3.5 border-b border-woodborder last:border-b-0 hover:bg-card/30 transition-colors" data-testid={`subscriber-row-${i}`}>
            <p className="flex-1 font-body text-cream text-sm truncate">{s.email}</p>
            <span className="font-mono text-[9px] tracking-[0.15em] text-tan hidden md:block">{(s.source || "site").toUpperCase()}</span>
            <span className="font-mono text-[10px] text-clay hidden sm:block">{fmtDate(s.created_at)}</span>
            <span className="font-mono text-[9px] tracking-[0.15em] text-gold-bright">ACTIVE</span>
            <button onClick={() => remove(s)} className="p-2 text-clay hover:text-red-400" data-testid={`subscriber-delete-${i}`} aria-label="Remove"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
